// extracted by mini-css-extract-plugin
module.exports = {"container":"Processor__container__2eS9o","priceContainer":"Processor__priceContainer__mb08k","reload":"Processor__reload__FZvNw"};